import React, { FC } from 'react';

import Input from '~/components/Input';

const FilterInput: FC<any> = props => <Input {...props} />;

export default FilterInput;
